<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <div>编辑班级</div>
                <div style="cursor: pointer;" @click="handleRefund">
                    <el-icon name="close" size="16"></el-icon>
                </div>
            </div>
            <div class="mask-content-body">
                <div class="mask-content-body-select">
                    <div class="mask-content-body-select-title">
                        班级类型<span>*</span>：
                    </div>
                    <div class="mask-content-body-select-input">
                        <el-select v-model="form.type" placeholder="请选择班级类型" popper-class="groupselsect"
                            popper-append-to-body>
                            <el-option v-for="item in banjitypeArr" :key="item.id" :label="item.values"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="mask-content-body-select">
                    <div class="mask-content-body-select-title">
                        班级名称<span>*</span>：
                    </div>
                    <div class="mask-content-body-select-input">
                        <el-input v-model="form.name" placeholder="请输入班级名称"></el-input>
                    </div>
                </div>
                <div class="mask-content-body-select">
                    <div class="mask-content-body-select-title">
                        班级地点<span>*</span>：
                    </div>
                    <div class="mask-content-body-select-input">
                        <el-input v-model="form.address" placeholder="请输入班级地点"></el-input>
                    </div>
                </div>
                <div class="mask-content-body-select" v-if="type == 2">
                    <div class="mask-content-body-select-title">
                        班级费用<span>*</span>：
                    </div>
                    <div class="mask-content-body-select-input">
                        <el-input v-model="form.fee" placeholder="请输入班级费用" type="number"></el-input>
                    </div>
                </div>
                <div class="mask-content-footer">
                    <div @click="handleRefund">取消</div>
                    <div @click="handleSubmit">确认</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddGroup",
    props: ["dataVal"],
    data() {
        return {

            form: {
                activity_id: '',
                name: '',
                address: '',
                type: '',
                fee: '',
                id: '',
            },
            banjitypeArr: [],

            type: '',  // 收费方式：1=统一收费，2=按班收费

            flag: false

        };
    },
    methods: {
        async dictionaryGetbanjitype() {
            let res = await this.$api.dictionaryGetbanjitype()
            if (res.code == 1) {
                this.banjitypeArr = res.data
            }
        },
        async activityActivitydetail() {
            let res = await this.$api.activityActivitydetail({
                id: this.form.activity_id
            })
            if (res.code == 1) {
                this.type = res.data.feeways
                this.activityBanjidetail()
            }
        },
        // 班级详情
        async activityBanjidetail() {
            let res = await this.$api.activityBanjidetail({
                id: this.form.id
            })
            if (res.code == 1) {
                this.form.name = res.data.name;
                this.form.address = res.data.address;
                this.form.type = res.data.type_id;
                this.form.fee = res.data.fee;
            }
        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false,
            };
            this.$emit("classEditCall", data);
        },
        async handleSubmit() {
            if (this.flag) {
                return false;
            }
            this.flag = true;
            let res = await this.$api.activityBanjiedit(this.form);
            if (res.code == 1) {
                this.flag = false;
                this.$message.success('修改成功')
                let data = {
                    flag: false, //弹窗是否显示
                    submitFlag: true, //是否调用接口
                };
                this.$emit("classEditCall", data);
            } else {
                this.flag = false;
            }
        },
    },
    watch: {
        dataVal: {
            handler(val) {
                if (val.flag) {
                    this.form.id = val.id
                    this.form.activity_id = val.activity_id
                    this.dictionaryGetbanjitype()
                    this.activityActivitydetail()
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000;

    .mask-content {
        width: 715px;
        border-radius: 10px;
        background: #fff;
        overflow: hidden;
        position: fixed;

        .mask-content-header {
            width: 100%;
            min-height: 50px;
            background: #c12e30;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;

            div {
                color: var(--Gray-White, #fff);
                font-size: 16px;
            }

            .el-icon-close {
                color: #fff;
            }
        }

        .mask-content-body {
            width: 100%;
            background-color: #fff;
            padding: 20px 20px 34px 20px;

            .mask-content-body-select {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .mask-content-body-select-title {
                    width: 87px;
                    color: #a6a6a6;
                    font-size: 14px;
                    display: flex;
                    align-items: center;

                    span {
                        color: #c12e30;
                    }
                }

                .mask-content-body-select-input {
                    flex: 1;

                    .el-select {
                        width: 100%;
                    }
                }
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 437px;

                div {
                    width: 120px;
                    height: 40px;
                    color: rgba(0, 0, 0, 0.9);
                    font-size: 14px;
                    border-radius: 5px 0 0 5px;
                    background: #edc2c3;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 0 5px 5px 0;
                        color: rgba(255, 255, 255, 0.9);
                        background: #b30003;
                    }
                }
            }
        }
    }
}
</style>